import { getRequest, deleteRequest, postRequest, patchRequest } from 'features/common'
import settings from 'settings'
import { AccessTokenResponse, TokenInfo } from '../types'

const { workspaceApiUrl } = settings

const TOKENS_URL = `${workspaceApiUrl}/tokens`
const TOKENS_USER_URL = `${TOKENS_URL}/user`

export const getCountAccessToken = async (): Promise<number> => {
  const params = new URLSearchParams({
    page: String(1),
    page_size: String(1)
  }).toString()
  const url = `${TOKENS_USER_URL}?${params}`
  const response = await getRequest(url)

  return response.meta.page.total
}

export const getAccessTokens = async (): Promise<AccessTokenResponse> => {
  const params = new URLSearchParams({
    isPaginated: String(false)
  }).toString()
  const url = `${TOKENS_USER_URL}?${params}`
  return getRequest(url)
}

export const getAccessToken = async (token: TokenInfo['token'] | undefined): Promise<TokenInfo> => {
  const url = `${TOKENS_URL}/${token}`
  return getRequest(url)
}

export const postAccessToken = async (data) => {
  const url = `${TOKENS_URL}`
  return postRequest(url, data)
}

export const patchAccessToken = async (id, data) => {
  const url = `${TOKENS_URL}/${id}`
  return patchRequest(url, data)
}

export const removeAccessToken = async ({ token }: { token: TokenInfo['token'] }) => {
  const url = `${TOKENS_URL}/${token}`
  return deleteRequest(url)
}
